const sound = window.AbdelmegedSound;

const interactiveSelector = [
  '.abdelmeged-mobile-design .abdelmeged-mobile-topbar__nav a',
  '.abdelmeged-mobile-design .abdelmeged-mobile-tabs a',
  '.abdelmeged-mobile-design .abdelmeged-mobile-back',
  '.abdelmeged-mobile-design .abdelmeged-mobile-article-card a',
  '.abdelmeged-mobile-design .abdelmeged-mobile-contact a',
  '.abdelmeged-mobile-design .abdelmeged-mobile-all-link',
].join(',');

if (sound) {
  document.addEventListener('pointerdown', (event) => {
    const target = event.target instanceof Element ? event.target.closest(interactiveSelector) : null;

    if (target) {
      sound.play('tap');
    }
  }, { passive: true });
}
